export enum UserIdEnum {
  Anonymous = 'anonymous',
  Current = 'current',
}
